import styled, { css } from 'styled-components'

import { color, radius } from '../../../themes'

interface ContainerProps {
  isMultipleLine?: boolean
  hasError: boolean
}

export const Container = styled.div<ContainerProps>`
  width: 100%;
  position: relative;

  &::after {
    content: '';
    transition: all 0.2s ease-in-out;
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    bottom: 0;
    pointer-events: none;

    ${({ isMultipleLine }) =>
      !isMultipleLine
        ? css`
            right: 100%;
            border-bottom: 1px solid ${color('gray.05')};
          `
        : css`
            right: 0;
            border: 1px solid ${color('gray.05')};
            border-radius: ${radius('md')};
          `}
  }

  ${({ hasError, isMultipleLine }) =>
    hasError &&
    css`
      &::after {
        ${!isMultipleLine
          ? css`
              right: 0;
              border-bottom: 1px solid ${color('red.01')};
            `
          : css`
              border: 1px solid ${color('red.01')};
            `}
      }
    `}

  &:focus-within {
    &::after {
      ${({ hasError, isMultipleLine }) =>
        css`
          ${!isMultipleLine
            ? !hasError
              ? css`
                  right: 0;
                  border-bottom: 1px solid ${color('blue.01')};
                `
              : css`
                  right: 0;
                  border-bottom: 1px solid ${color('red.01')};
                `
            : !hasError
            ? css`
                border: 1px solid ${color('blue.01')};
              `
            : css`
                border: 1px solid ${color('red.01')};
              `}
        `}
    }
  }
`
